// PrivateRoute.js
import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getDataHelper } from '../requests/PostRequests';

function PrivateRoute({ onTriggerMessage }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    async function validateSession() {
      await getDataHelper(
        "/auth/me",
        onTriggerMessage,
        () => setIsAuthenticated(true),
        () => setIsAuthenticated(false)
      );
    }

    validateSession();
  }, [onTriggerMessage]);

  if (isAuthenticated === null) {
    return null;
  }

  if (!isAuthenticated) {
    onTriggerMessage("Unauthorised", "User is not authenticated.", "danger");
  }

  return (
    isAuthenticated ? <Outlet /> : <Navigate to="/login" />
  );
}
export default PrivateRoute;
